// extracted by css-extract-rspack-plugin
export default {"label":"label--gHEjchrZRRED6aVl","checkboxContainer":"checkbox-container--Hn7VI0pPhQkmmxLj"};